import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/en/blog')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
